var _path, _path2, _circle, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 844.45966,
    height: 651.81364,
    viewBox: "0 0 844.45966 651.81364",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M789.8165,548.36629,680.47958,491.99471a7.00721,7.00721,0,0,1-3.01416-9.4292l6.76343-13.11816a7.00758,7.00758,0,0,1,9.42944-3.01416l109.33728,56.37158a7.00731,7.00731,0,0,1,3.014,9.4292l-6.76355,13.11816a6.95171,6.95171,0,0,1-4.09155,3.457,7.03373,7.03373,0,0,1-2.1438.33692A6.95572,6.95572,0,0,1,789.8165,548.36629Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#01bf71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M756.48209,495.63292a6.96559,6.96559,0,0,1,5.39414.14084l35.831,19.812a17.46934,17.46934,0,0,1,7.25338,22.95166l-.44889-.21865.44928.21893a17.48361,17.48361,0,0,1-21.47644,8.84216l-38.859-13.582a6.99947,6.99947,0,0,1-3.5732-9.237L752.606,499.33022a7.03706,7.03706,0,0,1,.74314-1.2945A6.95794,6.95794,0,0,1,756.48209,495.63292Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 661.15487,
    cy: 311.96782,
    r: 53.51916,
    fill: "#01bf71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M832.35788,768.90682V645.89315a7.00786,7.00786,0,0,1,7-7h14.75928a7.00786,7.00786,0,0,1,7,7V768.90682a7.00787,7.00787,0,0,1-7,7H839.35788A7.00787,7.00787,0,0,1,832.35788,768.90682Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#01bf71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M800.35788,768.90682V645.89315a7.00786,7.00786,0,0,1,7-7h14.75928a7.00786,7.00786,0,0,1,7,7V768.90682a7.00787,7.00787,0,0,1-7,7H807.35788A7.00787,7.00787,0,0,1,800.35788,768.90682Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#01bf71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M840.04948,455.897l.05567-2c-3.72071-.10352-7.001-.33692-9.46583-2.1377A6.148,6.148,0,0,1,828.258,447.231a3.51435,3.51435,0,0,1,1.15283-2.89453c1.63623-1.38183,4.269-.93457,6.188-.05469l1.65478.75879-3.17334-23.19043-1.98144.27149,2.69922,19.72656c-2.60743-.7666-5.02344-.43652-6.67823.96094a5.471,5.471,0,0,0-1.86035,4.49219,8.13264,8.13264,0,0,0,3.2002,6.07324C832.62663,455.689,836.74235,455.80422,840.04948,455.897Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 633.75783,
    y: 299.72959,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 667.75783,
    y: 299.72959,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M890.13937,666.24862,871.62875,544.63533a7.00713,7.00713,0,0,1,5.867-7.97314L892.087,534.441a7.00806,7.00806,0,0,1,7.97351,5.86719L918.571,661.921a7.00788,7.00788,0,0,1-5.86694,7.97363l-14.59119,2.22071a6.99379,6.99379,0,0,1-7.97351-5.8667Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#01bf71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M875.83371,588.191a6.96563,6.96563,0,0,1-3.05518-4.44776l-5.01916-40.63476a17.46934,17.46934,0,0,1,14.31128-19.354l.08679.49169-.08679-.49218a17.48361,17.48361,0,0,1,19.773,12.18408l11.8396,39.4248a6.99948,6.99948,0,0,1-5.37537,8.31836l-27.205,5.47412a7.03708,7.03708,0,0,1-1.48413.15918A6.95794,6.95794,0,0,1,875.83371,588.191Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M877.27017,676.09318H734.24747a8.50018,8.50018,0,0,1-7.594-12.31885L795.8024,526.26261a47.51643,47.51643,0,0,1,89.96777,21.34668V667.59318A8.50951,8.50951,0,0,1,877.27017,676.09318Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M840.82115,391.90662c-10.95586,2.44614-20.19653,9.58683-31.21246,11.80713-5.01962,1.01171-10.548.97035-15.15826-1.50054a15.79948,15.79948,0,0,1-7.33469-8.55937,23.62064,23.62064,0,0,1,3.76742-22.34144c6.18353-7.56951,16.04269-11.05754,25.50177-12.04062,18.93043-1.96743,38.37476,4.27063,53.78292,15.13717,15.90921,11.2199,28.11373,28.06738,32.20772,47.24127,2.18846,10.24952,1.97258,21.15269-1.764,31.0226a39.52833,39.52833,0,0,1-19.76885,21.54486,38.7961,38.7961,0,0,1-6.76575,2.51921,1.50128,1.50128,0,0,0,.79752,2.89283A42.73058,42.73058,0,0,0,899.64169,461.391c5.8611-9.375,7.82732-20.85222,6.92455-31.75949-1.74634-21.09933-13.34881-40.492-29.56871-53.768-15.58247-12.75428-35.73976-20.5145-56.00724-19.89794-10.16442.30921-20.71525,2.88942-28.6193,9.5874a26.91885,26.91885,0,0,0-9.34161,23.78683,21.57085,21.57085,0,0,0,4.73556,11.2939,19.518,19.518,0,0,0,12.52842,6.47021c11.984,1.56007,22.37578-5.233,32.96559-9.59955a51.26323,51.26323,0,0,1,8.35972-2.70489c1.88344-.42052,1.08637-3.31346-.79752-2.89284Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M870.92264,370.70475c-4.30291-16.10736,6.92623-32.87153,22.18366-37.90167a43.58532,43.58532,0,0,1,26.84.29943,52.9419,52.9419,0,0,1,22.11841,14.44056c13.37427,14.22833,19.299,33.43205,22.07122,52.36571,2.86236,19.54929,1.247,40.96059,11.25028,58.72519,4.14738,7.36522,10.3033,13.81434,18.25719,16.98577,7.42015,2.95861,16.30971,2.9725,23.41867-.87294a22.458,22.458,0,0,0,4.70549-3.437c1.40713-1.32778-.71706-3.44639-2.12132-2.12132-5.95279,5.61708-14.82531,6.67662-22.47648,4.47236-8.34538-2.40426-14.76863-8.81808-19.00146-16.2035-4.89491-8.54061-6.93322-18.30285-8.04481-27.98892-1.21346-10.57366-1.681-21.20427-3.30151-31.73482-2.92281-18.99328-9.23825-38.05862-22.63595-52.31188a56.3627,56.3627,0,0,0-22.27491-14.82068,47.22383,47.22383,0,0,0-27.27767-1.37732,37.20289,37.20289,0,0,0-20.50635,13.79,34.67929,34.67929,0,0,0-7.07262,22.53589,30.61611,30.61611,0,0,0,.97529,5.95259,1.50128,1.50128,0,0,0,2.89284-.79752Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M282.02994,507.09318H194.77017a17.01917,17.01917,0,0,1-17-17v-349a17.01917,17.01917,0,0,1,17-17H431.45108l43.31909,38.67822v70.32178h-2V163.66691L430.6879,126.09318H194.77017a15.017,15.017,0,0,0-15,15v349a15.017,15.017,0,0,0,15,15h87.25977Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M473.77017,164.09318h-27a17.01917,17.01917,0,0,1-17-17v-22a1,1,0,1,1,2,0v22a15.017,15.017,0,0,0,15,15h27a1,1,0,0,1,0,2Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.31021,214.59318h-228a8,8,0,0,0,0,16h228a8,8,0,0,0,0-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M325.31021,180.59318h-113a8,8,0,0,0,0,16h113a8,8,0,0,0,0-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.31021,281.59318a8,8,0,0,0,0,16h71.46v-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.31021,247.59318a8,8,0,1,0,0,16h71.46v-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M284.27017,451.09318h-64.04a16.51867,16.51867,0,0,1-16.5-16.5v-84a16.51868,16.51868,0,0,1,16.5-16.5h64.04Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M387.52994,614.59318H300.27017a17.01917,17.01917,0,0,1-17-17v-349a17.01917,17.01917,0,0,1,17-17H536.95108l43.31909,38.67822v66.32178h-2V271.16691L536.1879,233.59318H300.27017a15.017,15.017,0,0,0-15,15v349a15.017,15.017,0,0,0,15,15h87.25977Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M579.27017,271.59318h-27a17.01917,17.01917,0,0,1-17-17v-22a1,1,0,1,1,2,0v22a15.017,15.017,0,0,0,15,15h27a1,1,0,0,1,0,2Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M545.81021,322.09318h-228a8,8,0,0,0,0,16h228a8,8,0,0,0,0-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M430.81021,288.09318h-113a8,8,0,0,0,0,16h113a8,8,0,0,0,0-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M545.81021,322.09318h-228a8,8,0,0,0,0,16h228a8,8,0,0,0,0-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M430.81021,288.09318h-113a8,8,0,0,0,0,16h113a8,8,0,0,0,0-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M317.81021,389.09318a8,8,0,0,0,0,16h71.46v-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M317.81021,355.09318a8,8,0,0,0,0,16h71.46v-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M317.81021,389.09318a8,8,0,0,0,0,16h71.46v-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M317.81021,355.09318a8,8,0,0,0,0,16h71.46v-16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M389.77017,558.59318h-64.04a16.51867,16.51867,0,0,1-16.5-16.5v-84a16.51868,16.51868,0,0,1,16.5-16.5h64.04Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M395.41031,340.09318a16.99409,16.99409,0,0,0-8.14014,14.5v2.5h2v-2.5a15.02721,15.02721,0,0,1,11.1499-14.5Zm245.54-2.5H404.27017a17.01989,17.01989,0,0,0-17,17v349a17.0241,17.0241,0,0,0,17,17h263a17.0241,17.0241,0,0,0,17-17v-327.32Zm41.31982,366a15.01828,15.01828,0,0,1-15,15h-263a15.01828,15.01828,0,0,1-15-15v-349a15.02721,15.02721,0,0,1,11.1499-14.5,14.83265,14.83265,0,0,1,3.8501-.5H640.19009l42.08008,37.57Zm-286.85986-363.5a16.99409,16.99409,0,0,0-8.14014,14.5v2.5h2v-2.5a15.02721,15.02721,0,0,1,11.1499-14.5Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M683.27017,377.59318h-27a17.01917,17.01917,0,0,1-17-17v-22a1,1,0,0,1,2,0v22a15.017,15.017,0,0,0,15,15h27a1,1,0,0,1,0,2Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M649.81154,444.09318h-228a8,8,0,1,1,0-16h228a8,8,0,0,1,0,16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M534.81154,410.09318h-113a8,8,0,1,1,0-16h113a8,8,0,0,1,0,16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M649.81154,511.09318h-228a8,8,0,1,1,0-16h228a8,8,0,0,1,0,16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M534.81154,477.09318h-113a8,8,0,1,1,0-16h113a8,8,0,0,1,0,16Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M641.72891,664.59318h-212a16.51867,16.51867,0,0,1-16.5-16.5v-84a16.51868,16.51868,0,0,1,16.5-16.5h212a16.51867,16.51867,0,0,1,16.5,16.5v84A16.51866,16.51866,0,0,1,641.72891,664.59318Z",
    transform: "translate(-177.77017 -124.09318)",
    fill: "#01bf71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg-5.6b1ed06a1bac6b223cf9fd0f1f06f5fa.svg";
export { ForwardRef as ReactComponent };